// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_return/create_purchase_return.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseReturnItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseReturnRequest
 */
export class CreatePurchaseReturnRequest extends Message<CreatePurchaseReturnRequest> {
  /**
   * List of items to be returned
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseReturnItem items = 1;
   */
  items: PurchaseReturnItem[] = [];

  /**
   * Additional notes for the purchase return
   *
   * @generated from field: string notes = 2;
   */
  notes = "";

  /**
   * ID of the supplier to whom the items are being returned
   *
   * @generated from field: string supplier_id = 3;
   */
  supplierId = "";

  constructor(data?: PartialMessage<CreatePurchaseReturnRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseReturnRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: PurchaseReturnItem, repeated: true },
    { no: 2, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseReturnRequest {
    return new CreatePurchaseReturnRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseReturnRequest {
    return new CreatePurchaseReturnRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseReturnRequest {
    return new CreatePurchaseReturnRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseReturnRequest | PlainMessage<CreatePurchaseReturnRequest> | undefined, b: CreatePurchaseReturnRequest | PlainMessage<CreatePurchaseReturnRequest> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseReturnRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreatePurchaseReturnResponse
 */
export class CreatePurchaseReturnResponse extends Message<CreatePurchaseReturnResponse> {
  constructor(data?: PartialMessage<CreatePurchaseReturnResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePurchaseReturnResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePurchaseReturnResponse {
    return new CreatePurchaseReturnResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePurchaseReturnResponse {
    return new CreatePurchaseReturnResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePurchaseReturnResponse {
    return new CreatePurchaseReturnResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePurchaseReturnResponse | PlainMessage<CreatePurchaseReturnResponse> | undefined, b: CreatePurchaseReturnResponse | PlainMessage<CreatePurchaseReturnResponse> | undefined): boolean {
    return proto3.util.equals(CreatePurchaseReturnResponse, a, b);
  }
}

